<template>
  <b-container>
    <div class="exam__list">
      <h3 class="exam__list__title">Đề thi đã làm</h3>

      
      <div class="exam__category">
        <b-tabs justified>
          <template v-for="(category, index) in categories">
            <b-tab :key="category.id" :title="category.name">
              <template v-slot:title>
                <div :class="'category__item category__item--' + (index + 1)">
                  <div class="category__img">
                    <img :src="cdnUrl + category.thumbnail" alt="">
                  </div>
                  <h4 class="category__name">
                    {{ category.name }}
                  </h4>
                  <div class="category__count">({{ category.count }} Đề thi)</div>
                </div>
              </template>
              <b-row>
                <template v-for="exam in category.exams">
                  <b-col :key="exam.id" md="3" sm="4" xs="12">
                    <div class="exam__item">
                      <h4 class="exam__item__title">
                        <b-link
                          :to="{
                            name: 'exam-detail',
                            params: { id: exam.id, slug: exam.slug }
                          }"
                          :title="exam.description"
                          >{{ exam.name }}</b-link
                        >
                      </h4>
                      <div class="exam__item__time">
                        <img src="@/assets/images/ic_time.png" alt="" />
                        <span>{{ exam.time }} phút</span>
                      </div>

                      <b-link
                        :to="{
                          name: 'exam-detail',
                          params: { id: exam.id, slug: exam.slug }
                        }"
                        class="exam__item__btn"
                        >Xem chi tiết</b-link
                      >
                    </div>
                  </b-col>
                </template>
              </b-row>
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import { APP_CONFIG } from "@/utils/constants";

export default {
  name: "UserExamList",
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
    };
  },
  computed: {
    ...mapGetters({
      categories: `${STORE_KEY}/categories`,
      isLoadingExam: `${STORE_KEY}/isLoadingExam`
    })
  },
  beforeMount() {
    this.userExamCategory();
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["userExamCategory"])
  }
};
</script>
